import { Suspense } from "react"
import { faShieldCheck } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { QueryErrorBoundary } from "../../../../../../core/api/components/QueryErrorBoundary"
import { LoadingSpinner } from "../../../../../../shared/components/loading/LoadingSpinner"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { SUPPLIER_ADMIN_ROUTE } from "../../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { DevicesSupplierAdminResponse, fetchAllDevicesForSupplier } from "../supplierAdminApi"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { useApiQueryTable } from "../../../../../../core/api/components/ApiQueryTable"
import { DeviceTable } from "../../../../../entities/devices/components/DeviceTable"
import { DeviceTableVariant } from "../../../../../entities/devices/deviceTypes"
import { useCurrentSupplier } from "../../../../../suppliers/supplierHooks"

const selectDevices = (data: DevicesSupplierAdminResponse) => data?.devices || []

function SupplierDevicesTable() {
    const { supplierId } = useCurrentSupplier()

    const devicesResult = useApiQuery(fetchAllDevicesForSupplier, {
        queryName: "devices-for-supplier",
        dependencies: {
            supplierId: supplierId ?? 0,
        },
        enabled: Boolean(supplierId),
        select: selectDevices,
    })
    const { ApiQueryTable } = useApiQueryTable(devicesResult)

    return <DeviceTable variant={DeviceTableVariant.SUPPLIER} ApiQueryTable={ApiQueryTable} />
}

export function SupplierAdminDevices() {
    return (
        <>
            <LocalizedStrict id="supplier-admin-devices-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPLIER_ADMIN_DEVICES}
                    title="Payment acquiring agreement"
                    icon={<FontAwesomeIcon icon={faShieldCheck} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="supplier-nav-item-home">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-merchants">
                            <Breadcrumb>Merchants</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-devices">
                            <Breadcrumb>Devices</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <QueryErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                    <SupplierDevicesTable />
                </Suspense>
            </QueryErrorBoundary>
        </>
    )
}
